import React from "react";
// @mui/icons-material
// core components
import GridContainer from "/components/Grid/GridContainer.js";
import GridItem from "/components/Grid/GridItem.js";
import Card from "/components/Card/Card.js";
import CardHeader from "/components/Card/CardHeader.js";
import CardBody from "/components/Card/CardBody.js";
import CardFooter from "/components/Card/CardFooter.js";
import Muted from "/components/Typography/Muted.js";
import Button from "/components/CustomButtons/Button.js";

import styles from "./SectionImage.module.scss";

export default function SectionImage() {
  const classes = styles;
  return (
    <div
      className={classes.section}
      style={{ backgroundImage: "url('/img/bg10.jpg')" }}
    >
      <div className={classes.container}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={6}>
            <Card profile plain className={classes.textLeft}>
              <GridContainer>
                <GridItem xs={12} sm={5} md={5}>
                  <CardHeader image plain>
                    <a href="/about/profile-scott-sunderland">
                      <img
                        src="/img/faces/scott profile.jpeg"
                        alt="..."
                      />
                    </a>
                  </CardHeader>
                </GridItem>
                <GridItem xs={12} sm={7} md={7}>
                  <CardBody plain>
                    <h4 className={classes.cardTitle}>Scott Sunderland</h4>
                    <Muted>
                      <h6>AUTHOR OF THE MONTH</h6>
                    </Muted>
                    <p className={classes.description}>
                    We're in a pandemic... a pandemic of busy-ness! As a society we appreciate quality work.
                    </p>
                  </CardBody>
                  <CardFooter profile plain>
                      <a href = " https://twitter.com/ScottSunderl4nd" target="_blank">
                      <Button justIcon simple>
                        <i className="fab fa-twitter" />
                      </Button>
                      </a>
                      <a href = "https://www.linkedin.com/in/scott-sunderland-86780641/" target="_blank">
                      <Button justIcon simple>
                        <i className="fab fa-linkedin" />
                      </Button>
                      </a>
                      <a href = "https://github.com/guruscott"  target="_blank">
                      <Button justIcon simple>
                        <i className="fab fa-github" />
                      </Button>
                      </a>
                    </CardFooter>
                </GridItem>
              </GridContainer>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            <Card profile plain className={classes.textLeft}>
              <GridContainer>
                <GridItem xs={12} sm={5} md={5}>
                  <CardHeader image plain>
                    <a href="#pablo">
                      <img
                        src="/img/faces/card-profile4-square.jpg"
                        alt="..."
                      />
                    </a>
                  </CardHeader>
                </GridItem>
                <GridItem xs={12} sm={7} md={7}>
                  <CardBody plain>
                    <h4 className={classes.cardTitle}>Robert Dzudzar</h4>
                    <Muted>
                      <h6>AUTHOR OF THE WEEK</h6>
                    </Muted>
                    <p className={classes.description}>
                    Data is like the Universe, vast and powerful.
                    </p>
                  </CardBody>
                  <CardFooter profile plain>

                      <a href = "https://au.linkedin.com/in/robertdzudzar" target="_blank">
                        <Button justIcon simple>
                          <i className="fab fa-linkedin" />
                        </Button>
                      </a>
                    </CardFooter>
                </GridItem>
              </GridContainer>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
